import { useState, useEffect } from 'react';
import { sourcesService } from '@/services/sources';
import { SourceHistoryItem } from '@/types/sources';
import { useToast } from '@/hooks/use-toast';

export const useSourceHistory = (sourceId: string = '') => {
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(true);
  const [sourceHistory, setSourceHistory] = useState<SourceHistoryItem[]>([]);
  const [total, setTotal] = useState(0);
  const [error, setError] = useState<string | null>(null);

  const fetchHistory = async () => {
    if (!sourceId) {
      setSourceHistory([]);
      setTotal(0);
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      setError(null);
      const response = await sourcesService.getHistory(sourceId);
      setSourceHistory(response.data || []);
      setTotal(response.total || 0);
    } catch (err: any) {
      const errorMessage = err.message || 'Erro ao carregar histórico da fonte';
      setError(errorMessage);
      toast({
        variant: 'error',
        title: 'Erro ao carregar histórico',
        description: errorMessage,
      });
      console.error('Error fetching source history:', err);
      setSourceHistory([]);
      setTotal(0);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, [sourceId]);

  return {
    history: sourceHistory,
    total,
    isLoading,
    error,
    refetch: fetchHistory,
  };
};
